import { TRIAL_MOCK_IDS } from '../constants';

const CATEGORIES = [
  {
    id: 'trial-cat-001',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    name: 'Rent',
    approved: true,
    approved_by_expense_id: null,
    created_at: '2026-01-05T10:00:00Z',
    updated_at: '2026-01-05T10:00:00Z'
  },
  {
    id: 'trial-cat-002',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    name: 'Supplies',
    approved: true,
    approved_by_expense_id: null,
    created_at: '2026-01-05T10:00:00Z',
    updated_at: '2026-01-05T10:00:00Z'
  },
  {
    id: 'trial-cat-003',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    name: 'Travel',
    approved: true,
    approved_by_expense_id: null,
    created_at: '2026-01-05T10:00:00Z',
    updated_at: '2026-01-05T10:00:00Z'
  },
  {
    id: 'trial-cat-004',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    name: 'Utilities',
    approved: true,
    approved_by_expense_id: null,
    created_at: '2026-01-05T10:00:00Z',
    updated_at: '2026-01-05T10:00:00Z'
  }
];

const BRANCHES = [
  { id: TRIAL_MOCK_IDS.BRANCH_ID, name: TRIAL_MOCK_IDS.BRANCH_NAME },
  { id: 'trial-branch-002', name: 'North Branch' },
  { id: 'trial-branch-003', name: 'South Branch' }
];

let MOCK_EXPENSES = [
  {
    id: 'trial-exp-001',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Office Rent - May 2026',
    description: 'Monthly office space rental',
    branch_id: TRIAL_MOCK_IDS.BRANCH_ID,
    branch: BRANCHES[0],
    amount: '25000',
    date_of_expense: '2026-05-01T00:00:00Z',
    category_id: 'trial-cat-001',
    category: { id: 'trial-cat-001', name: 'Rent' },
    status: 'APPROVED',
    level: 'organisation',
    created_at: '2026-05-01T09:00:00Z',
    updated_at: '2026-05-02T11:00:00Z',
    files: []
  },
  {
    id: 'trial-exp-002',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Printer Cartridges',
    description: 'Replacement ink cartridges for office printers',
    branch_id: 'trial-branch-002',
    branch: BRANCHES[1],
    amount: '3500',
    date_of_expense: '2026-05-05T00:00:00Z',
    category_id: 'trial-cat-002',
    category: { id: 'trial-cat-002', name: 'Supplies' },
    status: 'APPROVED',
    level: 'branch',
    created_at: '2026-05-05T10:30:00Z',
    updated_at: '2026-05-06T14:00:00Z',
    files: []
  },
  {
    id: 'trial-exp-003',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Client Visit - Hyderabad',
    description: 'Travel expenses for client meeting',
    branch_id: TRIAL_MOCK_IDS.BRANCH_ID,
    branch: BRANCHES[0],
    amount: '8200',
    date_of_expense: '2026-05-08T00:00:00Z',
    category_id: 'trial-cat-003',
    category: { id: 'trial-cat-003', name: 'Travel' },
    status: 'APPROVED',
    level: 'organisation',
    created_at: '2026-05-08T16:00:00Z',
    updated_at: '2026-05-09T10:00:00Z',
    files: []
  },
  {
    id: 'trial-exp-004',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Electricity Bill - April',
    description: 'Monthly electricity charges',
    branch_id: 'trial-branch-003',
    branch: BRANCHES[2],
    amount: '4800',
    date_of_expense: '2026-05-10T00:00:00Z',
    category_id: 'trial-cat-004',
    category: { id: 'trial-cat-004', name: 'Utilities' },
    status: 'APPROVED',
    level: 'branch',
    created_at: '2026-05-10T09:00:00Z',
    updated_at: '2026-05-11T12:00:00Z',
    files: []
  },
  {
    id: 'trial-exp-005',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Stationery Purchase',
    description: 'Notebooks, pens, and folders',
    branch_id: TRIAL_MOCK_IDS.BRANCH_ID,
    branch: BRANCHES[0],
    amount: '1200',
    date_of_expense: '2026-05-12T00:00:00Z',
    category_id: 'trial-cat-002',
    category: { id: 'trial-cat-002', name: 'Supplies' },
    status: 'APPROVED',
    level: 'organisation',
    created_at: '2026-05-12T11:00:00Z',
    updated_at: '2026-05-12T15:00:00Z',
    files: []
  },
  {
    id: 'trial-exp-006',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Taxi Fare - Workshop',
    description: 'Cab to offsite workshop venue',
    branch_id: 'trial-branch-002',
    branch: BRANCHES[1],
    amount: '950',
    date_of_expense: '2026-05-14T00:00:00Z',
    category_id: 'trial-cat-003',
    category: { id: 'trial-cat-003', name: 'Travel' },
    status: 'PENDING',
    level: 'branch',
    created_at: '2026-05-14T18:00:00Z',
    updated_at: '2026-05-14T18:00:00Z',
    files: []
  },
  {
    id: 'trial-exp-007',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Internet Bill - May',
    description: 'Monthly broadband charges',
    branch_id: TRIAL_MOCK_IDS.BRANCH_ID,
    branch: BRANCHES[0],
    amount: '2400',
    date_of_expense: '2026-05-15T00:00:00Z',
    category_id: 'trial-cat-004',
    category: { id: 'trial-cat-004', name: 'Utilities' },
    status: 'PENDING',
    level: 'organisation',
    created_at: '2026-05-15T10:00:00Z',
    updated_at: '2026-05-15T10:00:00Z',
    files: []
  },
  {
    id: 'trial-exp-008',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Cleaning Supplies',
    description: 'Disinfectants and mops',
    branch_id: 'trial-branch-003',
    branch: BRANCHES[2],
    amount: '750',
    date_of_expense: '2026-05-16T00:00:00Z',
    category_id: 'trial-cat-002',
    category: { id: 'trial-cat-002', name: 'Supplies' },
    status: 'PENDING',
    level: 'branch',
    created_at: '2026-05-16T14:00:00Z',
    updated_at: '2026-05-16T14:00:00Z',
    files: []
  },
  {
    id: 'trial-exp-009',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Team Dinner - Rejected',
    description: 'Dinner with team (outside policy)',
    branch_id: TRIAL_MOCK_IDS.BRANCH_ID,
    branch: BRANCHES[0],
    amount: '6500',
    date_of_expense: '2026-05-04T00:00:00Z',
    category_id: 'trial-cat-003',
    category: { id: 'trial-cat-003', name: 'Travel' },
    status: 'REJECTED',
    level: 'organisation',
    created_at: '2026-05-04T20:00:00Z',
    updated_at: '2026-05-05T09:00:00Z',
    files: [],
    rejected_reason: 'Exceeds per-person limit for team outings'
  },
  {
    id: 'trial-exp-010',
    org_id: TRIAL_MOCK_IDS.ORGANIZATION_ID,
    title: 'Personal Uber Ride',
    description: 'Ride not related to office work',
    branch_id: 'trial-branch-002',
    branch: BRANCHES[1],
    amount: '450',
    date_of_expense: '2026-05-07T00:00:00Z',
    category_id: 'trial-cat-003',
    category: { id: 'trial-cat-003', name: 'Travel' },
    status: 'REJECTED',
    level: 'branch',
    created_at: '2026-05-07T22:00:00Z',
    updated_at: '2026-05-08T08:00:00Z',
    files: [],
    rejected_reason: 'Not a business-related expense'
  }
];

export const getExpenseStatsMock = () => ({
  total_expenses: '53750',
  total_transactions: 10,
  branch_expense_split: [
    {
      branch_id: TRIAL_MOCK_IDS.BRANCH_ID,
      branch_name: TRIAL_MOCK_IDS.BRANCH_NAME,
      total_expenses: '34100'
    },
    {
      branch_id: 'trial-branch-002',
      branch_name: 'North Branch',
      total_expenses: '4900'
    },
    {
      branch_id: 'trial-branch-003',
      branch_name: 'South Branch',
      total_expenses: '5550'
    }
  ],
  category_expense_split: [
    {
      category_id: 'trial-cat-001',
      category_name: 'Rent',
      total_expenses: '25000'
    },
    {
      category_id: 'trial-cat-002',
      category_name: 'Supplies',
      total_expenses: '5450'
    },
    {
      category_id: 'trial-cat-003',
      category_name: 'Travel',
      total_expenses: '16100'
    },
    {
      category_id: 'trial-cat-004',
      category_name: 'Utilities',
      total_expenses: '7200'
    }
  ],
  expense_status_split: [
    { status: 'APPROVED', total_expenses: '42700', total_transactions: 5 },
    { status: 'PENDING', total_expenses: '4100', total_transactions: 3 },
    { status: 'REJECTED', total_expenses: '6950', total_transactions: 2 }
  ]
});

export const getExpenseListMock = (
  status: string,
  page: number,
  limit: number
) => {
  let filtered = MOCK_EXPENSES;
  if (status && status !== 'all') {
    filtered = MOCK_EXPENSES.filter(
      (e) => e.status.toUpperCase() === status.toUpperCase()
    );
  }

  const start = page * limit;
  const items = filtered.slice(start, start + limit);

  return {
    items,
    total_count: filtered.length
  };
};

export const getExpenseCategoriesMock = () => CATEGORIES;

export const getExpenseDetailMock = (expenseId: string) => {
  const expense =
    MOCK_EXPENSES.find((e) => e.id === expenseId) || MOCK_EXPENSES[0];
  return { ...expense, attachments: [] };
};

export const approveExpenseMock = (expenseId: string) => {
  MOCK_EXPENSES = MOCK_EXPENSES.map((e) =>
    e.id === expenseId ? { ...e, status: 'APPROVED' } : e
  );
  return MOCK_EXPENSES.find((e) => e.id === expenseId) || MOCK_EXPENSES[0];
};

export const rejectExpenseMock = (expenseId: string, reason: string) => {
  MOCK_EXPENSES = MOCK_EXPENSES.map((e) =>
    e.id === expenseId
      ? { ...e, status: 'REJECTED', rejected_reason: reason }
      : e
  );
  return MOCK_EXPENSES.find((e) => e.id === expenseId) || MOCK_EXPENSES[0];
};
